/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import TableHeader from '@tiptap/extension-table-header';

export default TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        renderHTML: () => ({
          style:
            'border: 1px solid #84AFEF; background-color: #272D55; text-align: left; color: white; padding: 5px; padding-right: 20px; position: relative; min-height: 31px;',
        }),
      },
    };
  },
});
